// extracted by mini-css-extract-plugin
export var contrastLow = "_33-1";
export var externalLink = "_33-2";
export var externalLinkIcon = "_33-3";
export var link = "_33-0";
export var linkLabel = "_33-4";